import Paper from '@mui/material/Paper';
import MuiToggleButtonGroup, {
  toggleButtonGroupClasses,
} from '@mui/material/ToggleButtonGroup';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import * as React from 'react';

const StyledToggleButtonGroup = styled(MuiToggleButtonGroup)(({ theme }) => ({
  padding: 2,
  gap: 2,
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    // margin: '2px',
    minWidth: 32,
    borderRadius: theme.shape.borderRadius * 0.75,
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 0,
    },
  },
  [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]:
    {
      marginLeft: 0,
    },
  [`& .${toggleButtonGroupClasses.selected}`]: {},
}));

const ToggleButtonGroup = ({
  value,
  onChange,
  children,
  fullWidth,
  required = true,
  hasError,
  ...props
}) => {
  const handleChange = (e, v) => {
    if (required && v === null) {
      return;
    }
    onChange(e, v);
  };
  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: 'background.paper3',
        display: fullWidth ? 'flex' : 'inline-flex',
        transition: (theme) => theme.transitions.create(['border-color']),
        border: (theme) =>
          `1px solid ${hasError ? theme.palette.error.main : theme.palette.dividerVariant}`,
        flexWrap: 'wrap',
        borderRadius: 1,
      }}
    >
      <StyledToggleButtonGroup
        exclusive
        fullWidth={fullWidth}
        value={value}
        onChange={handleChange}
        {...props}
      >
        {children}
      </StyledToggleButtonGroup>
    </Paper>
  );
};

ToggleButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  hasError: PropTypes.bool,
  value: PropTypes.any,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default ToggleButtonGroup;

export { default as ToggleButton } from './ToggleButton';
